const state = {
  fetch: false,
};

const getters = {};

const actions = {};

const mutations = {
  setFetchState(state, value) {
    state.fetch = value;
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
